<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">{{collapsed?'':sysName}}
      </el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner test">
            <img :src="sysUserAvatar" />
            {{sysUserName}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>设置</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="getActiveItem($route.path)" class="el-menu-vertical-demo" @open="handleopen"
          @close="handleclose" @select="handleselect" unique-opened router v-show="!collapsed">
          <template v-for="(item,index) in $router.options.routes">
            <template v-if="!item.hidden">
              <el-submenu :index="index+''" v-if="!item.leaf" :key="index+'t'">
                <template slot="title">
                  <i :class="item.iconCls"></i>
                  {{item.name}}
                </template>
                <template v-for="child in item.children">
                  <el-menu-item :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item :key="index+'t'" v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
                <i :class="item.iconCls"></i>
                {{item.children[0].name}}
              </el-menu-item>
            </template>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <template v-for="(item,index) in $router.options.routes">
            <li :key="index+'ct'" v-if="!item.hidden" class="el-submenu item">
              <template v-if="!item.leaf">
                <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)"
                  @mouseout="showMenu(index,false)">
                  <i :class="item.iconCls"></i>
                </div>
                <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                  @mouseout="showMenu(index,false)">
                  <template v-for="child in item.children">
                    <li v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;"
                      :class="getActiveItem($route.path)==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}
                    </li>
                  </template>
                </ul>
              </template>
              <template v-else>
            <li class="el-submenu">
              <div class="el-submenu__title el-menu-item"
                style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;min-width: unset"
                :class="getActiveItem($route.path)==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)">
                <i :class="item.iconCls"></i>
              </div>
            </li>
          </template>
          </li>
</template>
</ul>
</aside>
<section class="content-container">
  <div class="grid-content bg-purple-light">
    <el-col :span="24" class="breadcrumb-container">
      <span :span="8" class="title"  ></span><!--{{$route.name}}-->
      <span :span="16" class="link">
        <span class="link-item" v-for="(item,index) in $route.matched" :key="item.path" :index='index'  @click="go(item.path)">{{ item.name }}</span>
      </span>
    </el-col>
    <el-col :span="24" class="content-wrapper">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-col>
  </div>
</section>
</el-col>
</el-row>
</template>

<script>
  export default {
    data() {
      return {
        loginUser: {
          avatar: require('../assets/avatar.png'),
          name: '管理员'
        },
        sysName: "一拉贯",
        collapsed: false,
        sysUserName: "",
        sysUserAvatar: "",
        form: {
          name: "",
          region: "",
          date1: "",
          date2: "",
          delivery: false,
          type: [],
          resource: "",
          desc: ""
        }
      };
    },
    methods: {
       getActiveItem(path) {
        let routes = this.$router.options.routes;
        let result = null
        let index = path.indexOf('/', 2);
        if (index == -1) {
          return path;
        }
        return path.slice(0,index);
      },
      onSubmit() {
        console.log("submit!");
      },
      handleopen() {
        //console.log('handleopen');
      },
      handleclose() {
        //console.log('handleclose');
      },
      handleselect: function (a, b) { },
      //退出登录
      logout: function () {
        var _this = this;
        this.$confirm("确认退出吗?", "提示", {
          //type: 'warning'
        })
          .then(() => {
            this.$http.removeToken();
            _this.$router.push("/login");
          })
          .catch(() => { });
      },
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
      },
      showMenu(i, status) {
        this.$refs.menuCollapsed.getElementsByClassName(
          "submenu-hook-" + i
        )[0].style.display = status ? "block" : "none";
      },
      go(path) {
        if (this.$route.path != path) {
         this.$router.push(path)
        }
      }
    },
    mounted() {
      console.log('$route.matched',this.$router.options.routes[4].children,this.$route.fullPath,this.$route.path)
      let temp = this.$router.options.routes[4].children.map((item) => {
        return {
          path: item.path,
          name: item.name
        };
      })
      console.log('temp---',temp)
      
      let userName = window.session.get('login-user');
      if(userName) {
        this.sysUserName = userName;
      } else {
        this.sysUserName = this.loginUser.name || "";
      }
      this.sysUserAvatar = this.loginUser.avatar || "";
    }
  };
</script>

<style scoped lang="scss">
  @import "../styles/vars.scss";
  .el-submenu .el-menu-item {
    min-width: 180px;
  }
  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    .link {
      float: right;
    }
    .link-item {
      cursor: pointer;
    }
    .link-item[index = '0'] {
      cursor: unset;
    }
    .link-item + .link-item:before {
      content: ' / ';
    }
    .header {
      height: 60px;
      line-height: 60px;
      background: $color-primary;
      color: #fff;

      .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;

        .userinfo-inner {
          cursor: pointer;
          color: #fff;

          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
        }
      }

      .logo {
        //width:230px;
        height: 60px;
        font-size: 22px;
        padding-left: 20px;
        padding-right: 20px;
        border-color: rgba(238, 241, 146, 0.3);
        border-right-width: 1px;
        border-right-style: solid;

        img {
          width: 40px;
          float: left;
          margin: 10px 10px 10px 18px;
        }

        .txt {
          color: #fff;
        }
      }

      .logo-width {
        width: 180px;
      }

      .logo-collapse-width {
        width: 60px;
      }

      .tools {
        padding: 0px 23px;
        width: 14px;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
      }
    }

    .main {
      display: flex;
      // background: #324057;
      position: absolute;
      top: 60px;
      bottom: 0px;
      overflow: hidden;

      aside {
        flex: 0 0 180px;
        width: 180px;

        // position: absolute;
        // top: 0px;
        // bottom: 0px;
        .el-menu {
          width: 180px;
          height: 100%;
        }

        .collapsed {
          width: 60px;

          .item {
            position: relative;
          }

          .submenu {
            position: absolute;
            top: 0px;
            left: 60px;
            z-index: 99999;
            background: #eee;
            height: auto;
            display: none;
          }
        }
      }

      .menu-collapsed {
        flex: 0 0 60px;
        width: 60px;
      }

      .menu-expanded {
        flex: 0 0 180px;
        width: 180px;
      }

      .content-container {
        // background: #f1f2f7;
        flex: 1;
        // position: absolute;
        // right: 0px;
        // top: 0px;
        // bottom: 0px;
        // left: 230px;
        overflow-y: scroll;
        padding: 20px;

        .breadcrumb-container {

          //margin-bottom: 15px;
          .title {
            width: 200px;
            float: left;
            font-weight: bolder;
            color: #475669;
          }

          .breadcrumb-inner {
            float: right;
          }
        }

        .content-wrapper {
          background-color: #fff;
          box-sizing: border-box;
        }
      }

      .el-submenu [class^="el-icon-"] {
        text-align: left;
      }
    }
  }
</style>